import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import cabanasImg from 'assets/images/amenitiesAndAttractions/kabany.jpg'
import cabanasImgMobile from 'assets/images/amenitiesAndAttractions/kabanyMobile.jpg'
import { useGetProductQuery } from 'store/api-slice/hooks'
import { useApp } from 'store/steps'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { useCart } from 'store/cart-slice/hooks'
import { useCabana } from 'store/cabana-slice/hooks'
import { setInitialData } from 'store/cabana-slice/index'
import CabanasCreator from '.'
import Attraction from 'components/shared/Attraction'
import CabanaModal from 'routes/Upsell/CabanaModal'
import { addCabana } from 'store/cabana-slice'
import { scrollToTop } from 'helpers/animateScroll'
import { useAutoScroll } from 'utils/hooks'
import { darkMode } from 'styles/theme'
import { usePromotions } from 'components/shared/Promotions/utils/usePromotions'
import { useTicketPromotions } from 'routes/Tickets/utils/useTicketPromotions'
import { CABANA_LOWEST_PRICE, CABANA_INCOMING_PRICE } from 'constants/prices'
import { getDarkModeByLanguage } from 'helpers/theme'

const CabanasAttraction = () => {
    const shouldEditorBeOpened =
        window.location.href.includes('#manage-cabanas')

    const dispatch = useAppDispatch()
    const { formatMessage } = useIntl()
    const { language } = useApp()
    const { isDarkThemeForCabanas } = usePromotions()
    const { renderActivePromotions } = useTicketPromotions()
    const { isStepEmpty } = useCart()
    const { removeCabanasFromCart, areCabanasProcessing, getInitialDate } =
        useCabana(null)
    const { calculateScroll, animatePendingScroll, scrollIndex } =
        useAutoScroll()

    const { data: cabanaProductInfo, isFetching: isProductInfoFetching } =
        useGetProductQuery({
            _locale: language,
            productType: 'cabana',
        })

    const { cabanas } = useAppSelector((state) => state.cabana)
    const { tickets } = useAppSelector((state) => state.cart.items)

    const [isCabanaModalOpen, setIsCabanaModalOpen] = useState(false)
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)

    const sectionId = 'cabanas-box'
    const areSubmittedCabanas = cabanas.some((cabana) => cabana.isSubmitted)

    const handleRemoveCabanas = () => {
        removeCabanasFromCart().then((isSuccess) => {
            if (isSuccess) {
                scrollToTop()
                setIsDropdownOpen(false)
            }
            window.history.pushState(
                {},
                document.title,
                window.location.pathname
            )
        })
    }

    const handleToggleCabanaModal = () =>
        setIsCabanaModalOpen(!isCabanaModalOpen)

    const handleAddCabana = () => {
        dispatch(addCabana({}))
        calculateScroll({
            trigerringSection: 'cabanas',
            trigerringAction: 'show',
        })
    }

    const handleButtonClick = () =>
        isDropdownOpen ? handleRemoveCabanas() : handleAddCabana()

    useEffect(() => {
        if (isProductInfoFetching) return
        dispatch(
            setInitialData({
                productId: cabanaProductInfo?.productId || '',
                unitPrice: cabanaProductInfo?.unitPrice || 0,
            })
        )
    }, [isProductInfoFetching])

    useEffect(() => {
        dispatch(
            setInitialData({
                date: getInitialDate(),
            })
        )
    }, [tickets.length])

    useEffect(() => {
        dispatch(
            setInitialData({
                date: getInitialDate(),
            })
        )
    }, [])

    useEffect(() => {
        if (cabanas.length === 0) {
            setIsDropdownOpen(false)
        } else setIsDropdownOpen(true)
    }, [cabanas.length])

    useEffect(() => {
        animatePendingScroll(sectionId)
        if (isDarkThemeForCabanas) animatePendingScroll('cabana-promo-info')
    }, [scrollIndex])

    useEffect(() => {
        if (isDropdownOpen) return
        shouldEditorBeOpened && setIsDropdownOpen(true)
        shouldEditorBeOpened && handleAddCabana()
    }, [shouldEditorBeOpened])

    useEffect(() => {
        if (!isStepEmpty('upsell')) return
        setIsDropdownOpen(false)
    }, [])

    return (
        <>
            <Attraction
                id={sectionId}
                isAvailableOnline={true}
                title="Cabana (16+)"
                price={cabanaProductInfo?.unitPrice}
                otherPrice={CABANA_INCOMING_PRICE}
                lowestPrice={CABANA_LOWEST_PRICE}
                isPriceFrom={false}
                pricePer="couple"
                details={[
                    formatMessage({
                        id: 'upsells.cabanas.abstract',
                        defaultMessage:
                            'Odpręż się na wygodnym łożu typu Cabana z baldachimem!',
                    }),
                ]}
                images={[cabanasImgMobile, cabanasImg]}
                creator={
                    <CabanasCreator
                        theme={
                            isDarkThemeForCabanas
                                ? getDarkModeByLanguage(language)
                                : undefined
                        }
                    />
                }
                handleModalOpening={handleToggleCabanaModal}
                isPriceLoading={isProductInfoFetching}
                isButtonLoading={!isDropdownOpen && areCabanasProcessing}
                isButtonDisabled={isDropdownOpen && areCabanasProcessing}
                isDropdownOpen={isDropdownOpen}
                handleButtonClick={handleButtonClick}
                isAdded={areSubmittedCabanas}
                theme={isDarkThemeForCabanas ? darkMode : undefined}
                hasDarkMode={isDarkThemeForCabanas}
                promotionBox={<>{renderActivePromotions({ key: 'cabana' })}</>}
            />
            <CabanaModal
                isOpened={isCabanaModalOpen}
                closeModal={handleToggleCabanaModal}
            />
        </>
    )
}

export default CabanasAttraction
